import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import CulturePillarModal from './CulturePillarModal';
import {CultureHouseCard} from '../../../../../../components/CultureHouseCard/CultureHouseCard';
import EmpionDialog from '../../../../../../components/EmpionDialog/EmpionDialog';
import {greenColors} from '../../../../../../layouts/theme/designSystem';
import {CultureHouseElement} from '../../types/CultureHouseTypes';

interface CultureHouseProps {
  cultureHouse: CultureHouseElement[];
  isClickable?: boolean;
}

export default function CultureHouse({cultureHouse, isClickable}: CultureHouseProps) {
  const {t} = useTranslation();

  const [dialogState, setDialogState] = useState({
    selectedElement: null as CultureHouseElement | null,
    isOpen: false,
  });

  const handleOpenDialog = (cultureHouseElement: CultureHouseElement) => {
    if (!isClickable) {
      return;
    }

    setDialogState({
      selectedElement: cultureHouseElement,
      isOpen: true,
    });
  };

  const handleCloseDialog = () => {
    setDialogState((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  };

  const subHeaderStyles: SxProps = {
    color: greenColors[700],
    verticalAlign: 'middle',
  };

  return (
    <Grid container mt={8}>
      <Grid item container alignItems={'self-end'}>
        <Typography variant='h2' mr={2}>
          {t('companyCultureDashboard.cultureHouse.header')}
        </Typography>
        {isClickable && (
          <Typography variant='body1' sx={subHeaderStyles}>
            {t('companyCultureDashboard.cultureHouse.subHeader')}
          </Typography>
        )}
      </Grid>
      <Grid item container mt={4} gap='32px'>
        {cultureHouse.map((pillar) => (
          <CultureHouseCard
            key={pillar.resourceId}
            cultureHouseElement={pillar}
            onClick={() => handleOpenDialog(pillar)}
            disabled={!isClickable}
          />
        ))}
        <EmpionDialog
          onClose={handleCloseDialog}
          open={dialogState.isOpen}
          sx={{maxHeight: '80%', margin: 'auto'}}
          maxWidth={'sm'}
        >
          <CulturePillarModal cultureHousePillar={dialogState.selectedElement} handleClose={handleCloseDialog} />
        </EmpionDialog>
      </Grid>
    </Grid>
  );
}
